var new_date = new Date(
  new Date().setDate(new Date().getDate() + 30)
).toLocaleDateString('es');
const siteTitle = 'Completar pedido';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Ingrese su información',
    formTitle2: 'Aquí pagas',
    btnForm: 'Continua',
    btnForm2: 'Paga',
    priceText1: 'Pago',
    priceText2: 'Total',
    footerTitle: 'Pago en línea',
    footerText: 'Confirmar con su tarjeta de crédito',
    shippingInfoText: 'Información de envío y facturación',
    paymentInfoText: 'INFORMACIÓN DE PAGO',
    agreengText:
      'Al hacer clic en "Continuar", confirmo que he leído, consentido y aceptado los Términos y Condiciones, la Política de Privacidad, y que tengo al menos 18 años de edad.',
    checkboxText:
      'Acepto recibir notificaciones de boletines, ofertas y servicios de comunicaciones.',
    bigFooterText: `Gracias a tu membresía, también participas en nuestro concurso para ganar el ${siteTitle}. Seleccionamos un ganador entre cada 600 participantes. El próximo ganador será seleccionado el ${new_date} y será notificado directamente por correo electrónico. Si la recompensa está agotada, el ganador recibirá en su lugar un producto similar de igual o mayor valor.`,
    bigFooterText1: `Nos aseguramos de que nuestros miembros reciban un historial detallado de las transacciones y, debido a esto, sepan lo que están pagando. La información de la tarjeta de crédito solo se requiere para facilitar futuras compras. No habrá cargos en el extracto de su tarjeta de crédito si no actualiza a la membresía PREMIUM y no realiza una compra.`,
    bigFooterText2: `Al unirse a este servicio, recibirá una prueba de 5 días del programa de nuestro socio. Si continúas con una suscripción más allá del período de prueba de 5 días, se te cargará un importe en tu tarjeta de crédito que varía según la tarifa elegida. Cuando su contribución se deduzca de su tarjeta de crédito u otro método de pago, tendrá acceso a estos servicios que están reservados exclusivamente para los miembros del sitio web de nuestro socio.`,
    subtotalText: 'Subtotal',
    amountText: 'Cantidad a pagar',
    shippingText: 'Envío',
    totalText: 'Total',
    freeText: 'Gratis',
    countryLabel: 'País',
    country: 'Spain',
  },
  home: {
    placeholder: {
      firstName: 'Primer nombre',
      lastName: 'Ultimo nombre',
      email: 'correo electrónico',
      phone: 'teléfono',
      city: 'Ciudad',
      address: 'Habla a',
      zip: 'cremallera',
      continue: 'Continuar',
      name: 'Nombre',
      confirmPayment: 'Confirmar pago',
    },
    cardNumber: 'numero de tarjeta',
    expirationDate: 'Fecha de validez',
    name: 'Nombre',
    month: 'mes',
    year: 'año',
    cvv: 'CVV',
    confirmPayment: 'Confirmar pago',
    timer: 'Tiempo restante hasta el pago del pedido',
    labelNumber: 'El número de tarjeta:',
    labelMonth: 'Fecha de vencimiento:',
    source:
      'Usamos seguridad 3D para verificar su compra. Puede aparecer una nueva ventana de verificación de transacciones',
  },
  validation: {
    requireEmail: 'Tu correo electrónico está vacío',
    validEmail: 'Email inválido.',
    requirePhone: 'Tu teléfono está vacío.',
    minPhone: 'El campo del teléfono debe tener al menos 10 caracteres.',
    requireFirstName: 'Se requiere el primer nombre.',
    validFirstName: 'El nombre no es válido',
    requireLastName: 'El campo de apellido es obligatorio.',
    validLastName: 'El campo de apellido no es válido',
    requireCity: 'El campo de la ciudad es obligatorio.',
    validCity: 'El campo de la ciudad no es válido',
    requireAddress: 'El campo de dirección es obligatorio.',
    validAddress: 'El campo de dirección no es válido',
    requireZip: 'El campo zip es obligatorio.',
    validZip: 'El campo zip no es válido.',
    requireCard: 'El campo del número de tarjeta es obligatorio.',
    minCard: 'Símbolos insuficientes.',
    validCard: 'El campo del número de tarjeta no es válido.',
    requireMonth: 'El campo del mes de vencimiento es obligatorio.',
    requireYear: 'El campo del año de vencimiento es obligatorio.',
    requireName: 'El campo de nombre es obligatorio.',
    validName: 'El campo de nombre no es válido.',
    requireCvv: 'El campo cvv es obligatorio.',
    validCvv: 'El campo cvv no es válido.',
    minFirstName: 'El campo de nombre debe tener al menos 3 caracteres.',
    minLastName: 'El campo de apellido debe tener al menos tres caracteres.',
    minCity: 'El campo de la ciudad debe tener al menos tres caracteres.',
    minAddress: 'El campo de dirección debe tener al menos tres caracteres.',
    minZip: 'El campo del código postal debe tener al menos tres caracteres.',
    minName: 'El campo de nombre debe tener al menos tres caracteres.',
    minCvv: 'El campo cvv debe tener al menos 3 caracteres.',
    specialFirstName:
      'El nombre del campo no debe contener caracteres especiales',
    specialLastName: 'El campo apellido no debe contener caracteres especiales',
    specialName: 'El nombre del campo no debe contener caracteres especiales',
    specialCity: 'La ciudad del campo no debe contener caracteres especiales.',
  },
  mask: {
    phone: '+34 999 999 999',
    zip: '9999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'ENTRAR EM CONTATO',
    firstName: 'primeiro nome',
    lastName: 'sobrenome',
    email: 'E-mail',
    msg: 'mensagem',
    send: 'send',
    alreadyRegistered: 'Você já se registrou',
    unsubscribeLink: 'Cancelar inscrição no link',
    worktime: 'O call center funciona das 10h às 17h',
    phone: 'Telefone: Sofia +359 2 437 4207',
  },
  footer: {
    title: 'Participa antes de que sea demasiado tarde',
    terms: 'Términos y condiciones',
    privacy: 'Política de privacidad',
    contact: {
      title: 'Contáctenos',
      text: 'Nos comprometemos a brindar a cada uno de nuestros valiosos clientes un excelente servicio al cliente. Si tiene alguna pregunta o inquietud, no dude en contactar a uno de nuestros representantes de servicio al cliente profesionales',
    },
  },
};
